import { useHistory } from "react-router-dom";
import { withProcedureWraper } from "../../../..";
import { useAFLColumns, useAFLRequests } from "../../../absence-letter/hooks";
import { AFLType } from "../../../absence-letter/models";
import { Box, Icon, Table, UserManual } from "../../../../../../components";
import CreateRequestButton from "../../../../components/CreateRequestButton";
import { Routes } from "../../../../../../AppRoutes";

const AbsenceLetterNoSalary = withProcedureWraper(() => {
  const history = useHistory();

  const { columns, columns2 } = useAFLColumns();
  const { isLoading, completedMyTSNRequests, myTSNRequests, myTSNRequestsNeedApproval } = useAFLRequests({
    aflType: AFLType.AFLNoSalary,
    department: ["TSN", "KCQ"],
  });

  const redirectToDetailPage = (requestId: string) => {
    history.push(`${Routes.absenceNoSalary.path}/${requestId}`);
  };

  const redirectToCreatePage = () => {
    history.push(`${Routes.absenceNoSalaryCreate.path}`);
  };

  return (
    <div className="pd15">
      <UserManual
        icon={<Icon.DocumentWrite />}
        title="ĐƠN XIN NGHỈ KHÔNG LƯƠNG"
        guideLink="https://drive.google.com/file/d/16RrfCW4U_z5SCJnbRmjKxFusx48wtRWA/view?usp=drive_link"
      />
      <Box title="Yêu cầu đã duyệt" titleRight={<CreateRequestButton onClick={redirectToCreatePage} />}>
        <Table
          rowKey="id"
          loading={isLoading}
          columns={columns2}
          dataSource={completedMyTSNRequests}
          onRow={(record: any) => ({
            onClick: () => redirectToDetailPage(record.id),
            style: { cursor: "pointer" },
          })}
          scroll={{ x: 1500 }}
        />
      </Box>
      <Box title="Yêu cầu cần duyệt">
        <Table
          rowKey="id"
          loading={isLoading}
          columns={columns2}
          dataSource={myTSNRequestsNeedApproval}
          onRow={(record: any) => ({
            onClick: () => redirectToDetailPage(record.id),
            style: { cursor: "pointer" },
          })}
          scroll={{ x: 1500 }}
        />
      </Box>
      <Box title="Tất cả yêu cầu">
        <Table
          rowKey="id"
          loading={isLoading}
          columns={columns}
          dataSource={myTSNRequests}
          onRow={(record: any) => ({
            onClick: () => redirectToDetailPage(record.id),
            style: { cursor: "pointer" },
          })}
          scroll={{ x: 1500 }}
        />
      </Box>
    </div>
  );
});

export default AbsenceLetterNoSalary;
